<template>
  <div class="venue-Detail">
    <h3>{{detailInfo.MeetingTitle }}
      <span v-if="detailInfo.ReservationState === 1" style="color:#5cadff;">（待审批）</span>
      <span v-else-if="detailInfo.ReservationState === 3" style="color:#19be6b;">（同意）</span>
      <span v-else-if="detailInfo.ReservationState === 4" style="color:#f05a4a;">（不同意）</span>
      <span v-else-if="detailInfo.ReservationState === 2" style="color:#f90;">（已撤销）</span>
    </h3>
    <p class="line-info">参会人数：{{detailInfo.UseNum}}</p>
    <p class="line-info">会议日期：{{detailInfo.StartTime.slice(0, 11)}}</p>
    <p class="line-info">会议时间：{{detailInfo.StartTime.slice(11, 16)}} - {{detailInfo.EndTime.slice(11, 16)}}</p>
    <p class="line-info">会议时长：{{detailInfo.UseTime}}</p>
    <p class="line-info">会议地点：{{detailInfo.HouseFullName}}</p>
    <p class="line-info">发起时间：{{detailInfo.CreateByDate.slice(0, 16)}}</p>
    <p class="line-info">主持人：{{detailInfo.FullName}}</p>
    <p class="line-info">预约说明：{{detailInfo.ReservIntroduction}}</p>
    <p class="line-info">参会人</p>
    <p class="line-info">{{detailInfo.UserNames.join(' ')}}</p>
    <div class="btn-line">
      <van-button type="default" @click="goBack">返回</van-button>
      <van-button type="primary" style="margin-left: 40px" v-if="detailInfo.ReservationState === 1"  @click="revokeConfirm">撤销</van-button>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'VenueMyAppointmentDetail',
    data() {
      return {
        detailInfo :{
          BuildingName: '',
          CreateByDate: '',
          EndTime: '',
          FullName: '',
          HouseFullName: '',
          HouseID: '',
          HouseName: '',
          Housenumber: '',
          IsStarted: '',
          MeetingID: '',
          MeetingTitle: '',
          ReservIntroduction: '',
          ReservationState: '',
          StartTime: '',
          UseNum: '',
          UseTime: '',
          UserNames: [],
          Volume: '',
          Week: ''
        }
      }
    },
    created() {
      this.getInfo(this.$route.params.id)
    },
    methods: {
      goBack() {
        this.$router.back()
      },
      revokeConfirm() {
        this.xy.confirm('撤销提示？', '您确定要撤销吗？', this.revoke)
      },
      async revoke () {
        let params = {
          reservationID:this.$route.params.id,
        }
        let res = await this.xyapi.get(this.$store.state.apiPath + '/api/MeetingReservation/Cancel', params)
        if(res.success) {
          this.xy.msgSuc('撤销成功')
          this.$router.back()
        }
      },
      async getInfo(id) {
        let params = {
          id
        }
        let res = await this.xyapi.get(this.$store.state.apiPath + '/api/MeetingReservation/Get', params)
        if(res.success) {
          res.data ? this.detailInfo = res.data : '';
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .venue-Detail {
    background: #ffffff;
    padding: 20px 20px 40px;
    .btn-line {
      margin-top: 30px;
      display: flex;
      justify-content: center;
    }
    h3 {
      font-size: 36px;
      font-weight: bold;
      padding-bottom: 30px;
      span {
        font-weight: normal;
        font-size: 28px;
      }
    }
    .line-info {
      padding-bottom: 30px;
      font-size: 28px;
    }
  }
</style>
